import template from './index.jst';
import './index.styl';
import { CorePrizes } from '../../../views';

export default class TippingPrizesView extends CorePrizes {
	get className() {
		return "tipping-help-page prizes-page";
	}

	get template() {
		return template;
	}
}